import BladeIcon from 'core/icons/blade';
import CalendarIcon from 'core/icons/calendar';
import ChevronDownIcon from 'core/icons/chevronDown';
import DMEIcon from 'core/icons/dme';
import FolderIcon from 'core/icons/folder';
import FractureIcon from 'core/icons/fracture';
import HomeIcon from 'core/icons/home';
import InjectionIcon from 'core/icons/injection';
import InventoryIcon from 'core/icons/inventory';
import MicIcon from 'core/icons/mic';
import MedicationsIcon from 'core/icons/medications';
import MoneyIcon from 'core/icons/money';
import NotificationIcon from 'core/icons/notification';
import OrthoticIcon from 'core/icons/orthotic';
import PinIcon from 'core/icons/pin';
import TaskIcon from 'core/icons/task';
import WoundCareIcon from 'core/icons/wound-care';
import XRayIcon from 'core/icons/xray';
import ImproveIcon from 'core/icons/improve';
import SaltIcon from 'core/icons/salt';
import TemplateIcon from 'core/icons/template';
import AIIcon from 'core/icons/ai';
import BillingIcon from 'core/icons/billing';
import ExpandSidebarIcon from 'core/icons/expandSidebar';
import CollapseSidebarIcon from 'core/icons/collapseSidebar';
import RefreshIcon from 'core/icons/refresh';
import SubmitIcon from 'core/icons/submit';
import DeleteIcon from 'core/icons/delete';
import FileStatusIcon from 'core/icons/fileStatus';
import UploadIcon from 'core/icons/upload';
import MailOpenIcon from 'core/icons/mailOpen';
import FaxIcon from 'core/icons/fax';
import ReportIcon from 'core/icons/report';
import DashboardIcon from 'core/icons/dashboard';
import ConsentFormIcon from 'core/icons/consentForm';
import MobileIcon from 'core/icons/mobile';
import PopulateMark from 'core/icons/populateMark';
import MasterTemplateIcon from 'core/icons/masterTemplate';
import SectionTemplatesIcon from 'core/icons/sectionTemplates';

export {
  BillingIcon,
  AIIcon,
  BladeIcon,
  CalendarIcon,
  ChevronDownIcon,
  DMEIcon,
  FolderIcon,
  FractureIcon,
  HomeIcon,
  InventoryIcon,
  InjectionIcon,
  MedicationsIcon,
  MicIcon,
  MoneyIcon,
  NotificationIcon,
  OrthoticIcon,
  PinIcon,
  SaltIcon,
  TaskIcon,
  TemplateIcon,
  WoundCareIcon,
  XRayIcon,
  ImproveIcon,
  ExpandSidebarIcon,
  CollapseSidebarIcon,
  UploadIcon,
  DeleteIcon,
  RefreshIcon,
  SubmitIcon,
  FileStatusIcon,
  MailOpenIcon,
  FaxIcon,
  ReportIcon,
  DashboardIcon,
  ConsentFormIcon,
  MobileIcon,
  PopulateMark,
  MasterTemplateIcon,
  SectionTemplatesIcon,
};
